export default __webpack_public_path__ + "static/media/DataNotFoundIcon.d753d190.png";